import LoadingButton from '@mui/lab/LoadingButton';
import { Typography } from '@mui/material';
import { useRef } from 'react';
import { StyledLink } from 'src/components/breadcrumbs/Breadcrumbs.styled';
import { CustomButton } from 'src/components/button/Button';
import { useOverflowHelper } from 'src/components/helpers/OverflowHelper';
import { CustomTooltip } from 'src/components/tooltip/CustomTooltip';
import { ViewOnlyAlert } from 'src/components/viewOnlyAlert';
import { lang } from 'src/utils';

import { ILayoutsEditPageHeader } from './LayoutsEditPageHeader.interface';
import {
  ActionButtonsContainer,
  CreateSectionsLayoutsText,
  HeaderContainer,
} from './LayoutsEditPageHeader.styles';

export const LayoutsEditPageHeader = ({
  layoutName,
  screenName,
  navigateBack,
  isViewOnly,
  isLoading,
  handleSaveScreen,
  isSaveDisabled,
}: ILayoutsEditPageHeader) => {
  const overflowRef = useRef<HTMLDivElement>(null);

  const overflow = useOverflowHelper(overflowRef, [layoutName]);

  return (
    <HeaderContainer>
      <CreateSectionsLayoutsText data-testid="CreateSectionsLayoutsText">
        {overflow ? (
          <CustomTooltip
            placement="right"
            title={layoutName}
            overflowLineNumber={1}>
            <StyledLink
              ref={overflowRef}
              underline={'hover'}
              color={'secondary.main'}
              onClick={navigateBack}>
              {layoutName}
            </StyledLink>
          </CustomTooltip>
        ) : (
          <StyledLink
            ref={overflowRef}
            underline={'hover'}
            color={'secondary.main'}
            onClick={navigateBack}>
            {layoutName}
          </StyledLink>
        )}
        <Typography variant="h3">{screenName}</Typography>
      </CreateSectionsLayoutsText>
      {isViewOnly ? (
        <ViewOnlyAlert />
      ) : (
        <ActionButtonsContainer spacing={2} direction="row">
          <CustomButton variant="text" onClick={navigateBack}>
            {lang.cancel}
          </CustomButton>
          <LoadingButton
            variant="contained"
            type="submit"
            loading={isLoading}
            disabled={isSaveDisabled}
            onClick={handleSaveScreen}>
            {lang.editLayoutsSidebar.saveScreen}
          </LoadingButton>
        </ActionButtonsContainer>
      )}
    </HeaderContainer>
  );
};
